import { ADD_SIDE_BAR_SHOW } from "./actionsTyprs";

export const addSideBarShow = dtSBS => {
  return {
    type: ADD_SIDE_BAR_SHOW,
    dtSBS,
  };
};
